var spoiler_default = {
  "fontElementMap": "xvSs5",
  "hideText": "xEnIy",
  "onHoverText": "ZLL8-",
  "hideBlock": "DQUeu",
  "smallBlur": "w06LY",
  "mediumBlur": "a9aso",
  "largeBlur": "dTG8J",
  "hideBlock_gallery": "pbCu3",
  "overlay": "FsqKD",
  "overlay_gallery": "UbbB-",
  "revealSpoilerBtn": "MndEF",
  "isMobile": "_5lJVD",
  "onHoverBtn": "SnG-q",
  "spoilerWrapper": "Gnhyj",
  "spoilerDescription": "_5k2X8",
  "spoilerContainer": "NHmAt",
  "spoilerContainer_Gallery": "EiAV5",
  "spoiler-text-blur": "a8LJo"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
